/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询当月演出,平台和剧院均可使用,注意传递正确channel
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  month: number,
  year: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.Holidays>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/product/show/month/${year}/${month}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
